<template>
    <div>
        <b-container fluid class="h-100">
            <b-row class="h-100">
                <b-col sm="6" lg="5" xl="4" class="pt-3" v-show="view != 'seguimiento' && view != 'notification'">
                    <b-form class="p-5" v-if="view == 'enviarcodigo'">
                        <b-form-group label="Correo electrónico"
                            description="Correo electrónico ingresado en el formulario.">
                            <b-form-input v-model="form.Email" type="email" data-test="email-input" />
                        </b-form-group>
                        <b-form-group label="Nº Ticket de atención" description="Ejemplo: CRT-XXXXXX">
                            <b-form-input v-model="form.NumDocumento" type="text" data-test="ticket-input" />
                        </b-form-group>
                        <b-alert v-if="!!vm.errores" show variant="danger">{{vm.errores}}</b-alert>
                        <b-form-group>
                            <div class="button-group">
                                <b-button class="btn-main px-4" @click="handleSendToken()" data-test="btn-send-token"
                                    :disabled="!(form.Email && form.NumDocumento)">
                                    Enviar código
                                </b-button>&nbsp;
                                <b-button class="btn-main px-4" @click="enableToken()" data-test="btn-have-token"
                                    :disabled="!(form.Email && form.NumDocumento)">
                                    Ya tengo un código &gt;&gt;
                                </b-button>
                            </div>
                        </b-form-group>
                    </b-form>
                    <b-form class="p-5" v-if="view == 'verificarcodigo'">
                        <b-form-group>
                            <b-link href="javascript:void(0)" @click="goBack()">&lt;&lt; Volver</b-link>
                        </b-form-group>
                        <b-form-group label="Código de acceso">
                            <p>
                                Ingrese el código de acceso que se ha enviado al correo registrado en el formulario.
                            </p>
                            <b-form-input v-model="form.Token" type="text" data-test="token-input" />
                        </b-form-group>
                        <b-form-group>
                            <b-button class="btn-main px-4" @click="handleSearch()" :disabled="!form.Token" data-test="btn-tracking">
                                Seguimiento de solicitud
                            </b-button>
                            <b-alert v-if="searchError" show variant="danger" class="mt-2">No se encontró ningún
                                documento asociado al código de acceso ingresado o ha vencido. Verifique y vuelva a
                                intentarlo.</b-alert>
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="bg-white pt-3" v-if="loading || Object.keys(solicitud).length">
                    <b-overlay variant="white" no-wrap :show="loading" opacity="1">
                        <template #overlay>
                            <div class="text-center">
                                <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
                                <p>Esto podrá tomar unos minutos.</p>
                            </div>
                        </template>
                    </b-overlay>

                    <div v-if="view === 'notification'" class="text-center notification p-5">
                        <img :src="notification.icon" />
                        <h5 class="my-4">{{ notification.title }}</h5>
                        <p class="mb-5">{{ notification.description }}</p>
                        <b-button v-if="notification.action" class="btn-alt px-4" @click="notification.event()">{{
                            notification.action }}</b-button>
                    </div>
                    <div v-else class="p-5">
                        <h3>{{ solicitud.Status }}</h3>
                        <p>{{ solicitud.Timestamp}}</p>
                        <div class="py-3" data-test="view-seguimiento-success">
                            <table>
                                <tr>
                                    <th>Nº de Ticket de atención:</th>
                                    <td class="pl-4">{{ solicitud.Numero }}</td>
                                </tr>
                                <tr valign="top">
                                    <th>Tipo de solicitud:</th>
                                    <td>
                                        <div>
                                            <div class="detalle-solicitud" :key="det.Id" v-for="(det, idy) in detalles">
                                                <h3>{{ det.TipoCertificado.Title }} <span
                                                        :class="`detalle-solicitud-status ${(det.PendientePago ? 'text-danger' : '')}`">[{{det.Estado.Title}}]</span><img
                                                        class="process-loading" v-if="det.EnProceso"
                                                        :src="require('../../assets/ajax-loader.gif')" /></h3>
                                                <b-button v-if="det.Atendido" :disabled="!!det.DownloadError"
                                                    class="btn-alt" size="sm" @click="handleDownload(det.Title)">
                                                    Descargar <img class="pl-2"
                                                        :src="require('../../assets/direct-download.png')" /></b-button>
                                                <b-alert v-if="!!det.DownloadError" show variant="danger" class="mt-2">
                                                    {{det.DownloadError}}</b-alert>
                                                <div>
                                                    <!--Solicitud aprobada, falta Constancia-->
                                                    <b-form
                                                        v-if="isPaymentPending && det.PendientePago && !det.EnProceso">
                                                        <p>Su solicitud ha sido aceptada, sírvase adjuntar su documento de identidad.</p>
                                                        <p class="text-danger" style="font-size: 0.9em;">Solo se aceptarán formatos PDF/JPG/PNG. Debe pesar menos de {{maxSize}}MB.</p>
                                                        <b-form-group label="Documento de Identidad"
                                                            :state="fileValid[idy]" :invalid-feedback="fileError[idy]">
                                                            <b-form-file ref="fupload" v-model="det.TempFiles"
                                                                data-test="file-input"
                                                                :state="fileValid[idy]"
                                                                :invalid-feedback="fileError[idy]" :multiple="true"
                                                                @input="filesLoaded(det, idy)"
                                                                placeholder="Ningún archivo seleccionado"
                                                                browse-text="Seleccionar..."
                                                                class="form-control form-control-sm h-auto p-3">
                                                            </b-form-file>
                                                            <div class="file-group">
                                                                <b-button variant="primary"
                                                                    v-for="(f, idx) in det.Files" :key="`${f.name}-${idx}`">
                                                                    {{f.name}} <b-badge
                                                                        @click.stop="removeFile(det, idx)" :data-test="`btn-remove-file-${idx}`"
                                                                        variant="light">X</b-badge>
                                                                </b-button>
                                                            </div>
                                                        </b-form-group>
                                                        <b-form-group label="Tipo de Comprobante"
                                                            description="Indique el comprobante de su preferencia">
                                                            <b-form-radio-group id="chkg-TipoCertificado"
                                                                v-model="det.TipoComprobante"
                                                                @change="cambiarTipoComprobante(det)">
                                                                <b-form-radio v-for="option in vm.tiposComprobante"
                                                                    :key="option" :value="option" class="my-1">
                                                                    {{ option }}
                                                                </b-form-radio>
                                                            </b-form-radio-group>
                                                        </b-form-group>
                                                        <b-form-group label="RUC"
                                                            v-if="det.TipoComprobante == 'Factura'">
                                                            <b-form-input v-model="det.RUC" type="text"
                                                                :state="det.RUC==null? null : !!det.RUC"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group label="Razón Social"
                                                            v-if="det.TipoComprobante == 'Factura'">
                                                            <b-form-input v-model="det.RazonSocial" type="text"
                                                                :state="det.RazonSocial==null? null : !!det.RazonSocial">
                                                            </b-form-input>
                                                        </b-form-group>
                                                    </b-form>
                                                </div>
                                            </div>
                                            <div v-if="isPaymentPending">
                                                <b-form-group>
                                                    <vue-recaptcha ref="secondRecaptcha" @verify="onVerify"
                                                        @expired="onExpired"
                                                        sitekey="6LcRnskZAAAAAPvUexc-7yyr8LqIgcXguWV8MeFX">
                                                    </vue-recaptcha>
                                                </b-form-group>
                                                <b-form-group>
                                                    <b-button class="btn-alt px-4" @click="(event)=>handleSubmit()" data-test="btn-send-voucher"
                                                        :disabled="uploadDisabled">
                                                        Enviar documentos
                                                        <img class="pl-2"
                                                            :src="require('../../assets/arrow-right.png')" />
                                                    </b-button>
                                                </b-form-group>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!--Solicitud aprobada, archivos listos para descargar-->
                        <b-form v-if="false">
                            <b-form-group>
                                <p>Su certificado ha sido generada</p>
                                <b-button class="btn-alt pl-3 pr-4" @click="handleDownload">
                                    <img class="pr-2" :src="require('../../assets/direct-download.png')" />
                                    Descargar
                                </b-button>
                            </b-form-group>
                        </b-form>
                        <b-card>
                            <div @click="historial = !historial"
                                class="d-flex justify-content-between align-items-center pointer">
                                <h5 class="pointer m-0">Detalle histórico</h5>
                                <img class="pl-2"
                                    :src="require(historial ? '../../assets/chevron-up.png' : '../../assets/chevron-down.png')" />
                            </div>
                            <b-collapse id="historial" v-model="historial" class="mt-4">
                                <div class="timeline">
                                    <div v-for="(item, index) in timeline" :key="index">
                                        <h6>{{ item.Status }}</h6>
                                        <p>{{ item.Fecha }} <br /> {{ item.Descripcion }}</p>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import {EstadosCertificado} from '../../utils/constants'
import {sendToken, getSeguimientoSolicitud, uploadVouchersSolicitud, getAttachmentToken, getAttachmentUrl} from '../../api/CounterApi';
import moment from 'moment';

export default {
    name: 'SeguimientoSolicitud',
    components: { VueRecaptcha },
    data(){
        return {
            form: {},
            solicitud: {},
            currentDetalle: null,
            detalles: [],
            loading: false,
            historial: false,
            searchError: false,
            timeline: [{
                Status: 'Estado',
                Fecha: '18 de setiembre',
                Descripcion: 'Descripción del estado'
            },
            {
                Status: 'Estado',
                Fecha: '12 de setiembre',
                Descripcion: 'Descripción del estado'
            }],
            ccode: '',
            isPaymentPending: false,
            isCompleted: false,
            view: 'enviarcodigo',
            // fileValid: [],
            // fileError: [],
            downloadError: '',
            maxSize: parseInt(config.VUE_APP_MAXLIMIT ? config.VUE_APP_MAXLIMIT: process.env.VUE_APP_MAXLIMIT),
            downloadLimit: parseInt(config.VUE_APP_LIMITDOWNLOAD ? config.VUE_APP_LIMITDOWNLOAD: process.env.VUE_APP_LIMITDOWNLOAD),
            vm: {
                errores: '',
                tiposComprobante: ['Boleta', 'Factura']
            }
        }
    },
    created(){
        this.currentDetalle = null;
    },
    methods: {
        NuevoSeguimiento() {
            this.loading = true;
            
            this.form = {};
            this.sol = {};
            this.timeline = [];
            this.ccode = '';
            this.historial = false;
            this.view = 'seguimiento';

            this.loading = false;
        },
        removeFile(det, idx){
            det.Files.splice(idx, 1);
        },
        filesLoaded(det, idy){
            det.Files = det.Files.concat(det.TempFiles);
            
            det.TempFiles = [];
            this.$refs.fupload[idy].reset();
        },
        goBack(){
            this.view = 'enviarcodigo';
            this.form.Token = '';
            this.vm.errores = '';
            this.searchError = false;
        },
        async handleSendToken() {
            this.loading = true;
            
            this.isPaymentPending = false;
            this.vm.errores = '';

            let token = await sendToken(this.form.Email, this.form.NumDocumento);

            if(token.success){
                this.view = 'verificarcodigo';
            }else {
                this.vm.errores = token.message
                this.view = 'enviarcodigo';
            }
            this.loading = false;
        },
        enableToken(){
            this.view = 'verificarcodigo';
            this.vm.errores = '';
        },
        async handleSearch() {
            this.loading = true;
            this.view = 'seguimiento';
            this.isPaymentPending = false;
            this.searchError = false;
            this.downloadError = '';

            let seg = await getSeguimientoSolicitud(this.form.Email, this.form.NumDocumento, this.form.Token);

            if(seg.success){
                this.solicitud = {
                    Status: seg.value.Solicitud.Estado.Title,
                    Timestamp: seg.value.Historial.length > 0 ? moment(seg.value.Historial[seg.value.Historial.length-1].Modified).format('DD/MM/YYYY HH:mm:SS') : '',
                    Numero: seg.value.Solicitud.Title,
                    Tipo: seg.value.Solicitud.TipoCertificado,                    
                }

                this.downloadError = seg.value.Solicitud.FechaEnvioDocumento && moment().diff(moment(seg.value.Solicitud.FechaEnvioDocumento),'days') > this.downloadLimit ? `Han pasado más de ${this.downloadLimit} días desde su atención, debe volver a solicitar el certificado / constancia.` : '';

                this.detalles = seg.value.Detalles.map(d => ({
                    ...d, 
                    Atendido: d.Estado.Id == EstadosCertificado.Atendido || d.Estado.Id == EstadosCertificado.Completado, 
                    PendientePago: d.Estado.Id == EstadosCertificado.PendientePago, 
                    UploadVoucher: false,
                    TipoComprobante: 'Boleta',
                    RUC: '',
                    RazonSocial: '',
                    EnProceso: d.EnProceso,
                    DownloadError: d.FechaEnvioDocumento && moment().diff(moment(d.FechaEnvioDocumento),'days') > this.downloadLimit ? `Han pasado más de ${this.downloadLimit} días desde su atención, debe volver a solicitar el certificado / constancia.` : '', 
                    Files: [], 
                    TempFiles: []}));


                this.isPaymentPending = this.detalles.filter(d => d.PendientePago && !d.EnProceso).length > 0;

                this.timeline = seg.value.Historial.map(h => ({
                    Status: h.NuevoEstado,
                    Fecha: moment(h.Modified).format('DD/MM/YYYY HH:mm:SS'),
                    Descripcion: h.Observaciones
                }));

                //this.isPaymentPending = (seg.value.Solicitud.Estado.Id == EstadosCertificado.PendientePago);
                this.isCompleted = (seg.value.Solicitud.Estado.Id == EstadosCertificado.Completado);
            } else {
                this.view = 'verificarcodigo';
                this.searchError = true;
            }
            this.loading = false;
        },
        async setDetalle(codDetalle){
            this.currentDetalle = codDetalle;
        },
        cambiarTipoComprobante(det){
            if(det.TipoComprobante == 'Boleta'){
                det.RUC = null;
                det.RazonSocial = null;
            }
        },
        async handleSubmit() {
            this.loading = true;
            let vmSeg = this;
            //let search = this.handleSearch;
            //enviar voucher
            
            let filesInfo = [];
            this.detalles.filter(det => det.Files.length > 0).forEach(function(det){
                det.Files.forEach(function(f){
                    filesInfo.push({Detalle: det.Title, File: f, TipoComprobante: det.TipoComprobante, RUC: det.TipoComprobante == 'Factura'?det.RUC:'', RazonSocial: det.TipoComprobante == 'Factura'?det.RazonSocial:''});
                })
            });

            let result = await uploadVouchersSolicitud(this.ccode, this.form.NumDocumento, this.form.Token, filesInfo);
            if(result.success){
                this.notification = {
                    icon: require('../../assets/success.svg'),
                    title: 'Voucher enviado con éxito',
                    description: 'Una vez confirmado el pago, enviaremos los detalles de tu solicitud vía correo electrónico.',
                    action: 'Nuevo seguimiento',
                    event: function(){                            
                        vmSeg.view = 'enviarcodigo' ;
                        vmSeg.form.Email = '';
                        vmSeg.form.NumDocumento = '';
                        vmSeg.form.Token = '';
                        vmSeg.solicitud = {};
                    }
                }
            } else {
                this.notification = {
                    icon: require('../../assets/success.svg'),
                    title: '¡Error!',
                    description: 'Hubo un error durante el envío, intente nuevamente en un momento.',
                    action: 'Volver a intentarlo',
                    event: function(){
                        vmSeg.view = 'seguimiento'
                    }
                }
            }
            this.view = 'notification';
            this.loading = false;
        },
        async handleDownload(detalle) {
            this.downloadError = '';
            //descargar archivo(s)
            let res = await getAttachmentToken(this.form.NumDocumento, detalle, this.form.Token);
            if(res.success){
                let url = getAttachmentUrl(res.value);
                window.open(url, '_blank'); 
            } else {
                this.downloadError = res.message;
            }
        },
        onVerify(res) {
            this.$set(this.solicitud, 'Recaptcha', res);
            this.ccode = res;
        },
        onExpired() {
            this.solicitud.Recaptcha = '';
        },
        resetRecaptcha() {
            this.$refs.secondRecaptcha.reset();
        },
    },
    computed: {
        uploadDisabled(){
            const recaptcha = (process.env.VUE_APP_TESTING_MODE == 'true'? 'testcaptcha' : this.solicitud.Recaptcha);
            const allFiles = this.detalles.reduce((acc, d)=> acc+d.Files.length, 0);
            return !(recaptcha) || allFiles < 1 || this.fileValid.filter(f => f === false).length > 0 || (this.detalles.filter(d => (d.PendientePago && !d.EnProceso && (!d.TipoComprobante || (d.TipoComprobante == 'Factura' && (!d.RUC || !d.RazonSocial))))).length > 0);
        },
        fileValid(){
            const vm = this;
            return vm.detalles.map(det => {
                let totalSize = det.Files.reduce((acc, f1)=> acc + f1.size, 0);
                let totalFiles = vm.detalles.reduce((acc, d)=> acc+d.Files.length, 0);
                
                return det.Files.length > 0? (totalSize <= vm.maxSize*1024*1024 && totalFiles > 0) : null;
            });
        },
        fileError(){
            const vm = this;
            return vm.detalles.map(det => {
                let totalSize = det.Files.reduce((acc, f1)=> acc + f1.size, 0);
                let totalFiles = vm.detalles.reduce((acc, d)=> acc+d.Files.length, 0);
                
                return (totalSize > vm.maxSize*1024*1024 ? `El archivo no debe pesar más de ${this.maxSize}MB en conjunto.` : (totalFiles < 1 ? 'Debe adjuntar el Documento de identidad.':null));
            });
        }
    }
}
</script>
<style>
.form-group {
    margin-bottom: 2rem !important;
}

label:not(.custom-control-label), legend, .col-form-label {
    color: #034087 !important;
    font-family: 'ProximaNova-SemiBold';
    font-size: 18px;
    padding-bottom: 1rem!important;
}

.box {
    overflow-y: auto;
    max-height: 160px;
    background-color: #ffffff;
    border: 2px solid #EFEDED;
    padding: 5px 12px;
}

.custom-control-input:checked ~ .custom-control-label::before, .btn-main {
    background-color: #034087 !important;
    border-color: #034087 !important;
}
.btn-alt {
    background-color: #EB0029 !important;
    border-color: #EB0029 !important;
}
.btn {
    font-family: 'ProximaNova-Regular' !important;
    border-radius: 0.5rem;
}
.btn:disabled {
    background-color: #EFEDED !important;
    border-color: #EFEDED !important;
}
.pointer {
    cursor: pointer;
}
.notification img {
    max-width: 140px
}

h3, .card h5 {
    font-family: 'ProximaNova-Semibold';
    color: #034087;
}
.card h5 {
    font-size: 18px;
    line-height: 18px;
}
.bg-light {
    background-color: #f6f6f6 !important;
}
.b-overlay {
    color: #40D7D7;
}
.b-overlay .spinner-border {
    height: 5rem;
    width: 5rem;
    border-width: 0.5rem;
}
.my-1{ display: block; }

.timeline > div {
    position: relative;
    padding-left: 30px;
}
.timeline > div:not(:last-child):before {
    content: ' ';
    height: 100%;
    width: 1px;
    background-color: #ced4da;
    top: 17px;
    left: 8px;
    position: absolute;
}
.timeline h6 {
    color:#4f5e6d;
    font-family: 'ProximaNova-Semibold';
}
.timeline > div:after {
    content: '';
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: #40D7D7;
    position: absolute;
    top: 3px;
    left: 2px;
}
.detalle-solicitud h3{
    color: #034087 !important;
    font-weight: bold;
    font-size: 1.1em;
}

.detalle-solicitud-status{
    text-transform: uppercase;    
}
img.process-loading{
    margin-left: 15px;
    height: 16px;    
    margin-top: -2px;
}

.file-group button,
.button-group button { margin-top: 5px; margin-right: 5px; }
</style>